import React from 'react';
import PropTypes from 'prop-types';
import { HideOnMobile, ProgressBar } from '@web/atoms';
import { BaseHeader, PromoPill, DiscountBanner } from '@web/molecules';
import {
  BreadcrumbContainer,
  CurrentProgress,
  PromoPillContainer,
} from './styles';

export const QuizHeader = ({
  currentStep,
  totalSteps,
  showPromoBar,
  discountBannerCopy,
  discountBannerBGColor,
  discountBannerFontColor,
}) => {
  const rightHeaderSegment = (
    <HideOnMobile>
      {!showPromoBar && (
        <PromoPillContainer>
          <PromoPill />
        </PromoPillContainer>
      )}
    </HideOnMobile>
  );

  const topHeaderSegment = (
    <>
      {showPromoBar && (
        <DiscountBanner
          croCopy={discountBannerCopy}
          bgColor={discountBannerBGColor}
          fontColor={discountBannerFontColor}
        />
      )}
      <ProgressBar
        currentStep={currentStep}
        totalSteps={totalSteps}
        labelText={`Signup step ${currentStep} of ${totalSteps}`}
      />
      <BreadcrumbContainer>
        <CurrentProgress>
          Pup Quiz ({currentStep}/{totalSteps})
        </CurrentProgress>
      </BreadcrumbContainer>
    </>
  );

  return (
    <BaseHeader
      topSegment={topHeaderSegment}
      rightSegment={rightHeaderSegment}
    />
  );
};

QuizHeader.displayName = 'QuizHeader';

QuizHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  showPromoBar: PropTypes.bool,
  discountBannerCopy: PropTypes.string,
  discountBannerBGColor: PropTypes.string,
  discountBannerFontColor: PropTypes.string,
};
